import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface VideoModalData {
  videoUrl: string;
  title?: string;
  isLoading?: boolean;
}

@Component({
  standalone: true,
    selector: 'app-video-modal',
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule
    ],
    template: `
    <div class="video-modal-container">
      <div class="video-modal-header">
        <h2 *ngIf="data.title">{{ data.title }}</h2>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="video-modal-content">
        <!-- Loading spinner -->
        <div *ngIf="data.isLoading" class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Video wird geladen...</p>
        </div>
        
        <!-- Video player (only shown when not loading) -->
        <video 
          *ngIf="!data.isLoading && data.videoUrl"
          #videoPlayer
          [src]="data.videoUrl" 
          controls 
          autoplay
          preload="auto"
          class="video-player">
          <source [src]="data.videoUrl" type="video/mp4">
          Ihr Browser unterstützt das Video-Tag nicht.
        </video>
        
        <!-- Error message if video URL is empty and not loading -->
        <div *ngIf="!data.isLoading && !data.videoUrl" class="error-container">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <p>Das Video konnte nicht geladen werden. Bitte versuchen Sie es später erneut.</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .video-modal-container {
      background-color: #1a1a1a;
      color: white;
      display: flex;
      flex-direction: column;
      max-width: 90vw;
      max-height: 90vh;
      overflow: hidden;
    }

    .video-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: var(--spacing-md) var(--spacing-lg);
      background-color: rgba(0, 0, 0, 0.3);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    h2 {
      margin: 0;
      font-size: 1.5rem;
      color: var(--color-accent);
    }

    .video-modal-content {
      width: 100%;
      max-width: 1200px;
      aspect-ratio: 16 / 9;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .video-player {
      width: 100%;
      height: 100%;
      background-color: #000;
    }
    
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      
      p {
        margin-top: 20px;
        color: var(--color-text-light);
      }
    }
    
    .error-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      padding: 20px;
      text-align: center;
      
      .error-icon {
        font-size: 48px;
        height: 48px;
        width: 48px;
        color: #f44336;
        margin-bottom: 16px;
      }
      
      p {
        color: var(--color-text-light);
        max-width: 400px;
      }
    }

    @media (max-width: 768px) {
      .video-modal-container {
        max-width: 100vw;
        max-height: 100vh;
      }
    }
  `]
})
export class VideoModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<VideoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VideoModalData
  ) {
    this.dialogRef.addPanelClass('video-modal-dialog');
    
    // Set default values
    this.data.isLoading = this.data.isLoading ?? false;
  }

  ngOnInit(): void {
    // Ensure the video URL is correct
  }

  close(): void {
    this.dialogRef.close();
  }
} 